export default __webpack_public_path__ + "static/media/tire.0b44e8b4.svg";